<template>
  <router-link
    :to="{ path: linkTo, query: $route.query }"
    tag="section"
    class="box"
    :style="styleObj"
    @click.native="linkView(linkTo)"
  >
    <div class="box-img">
      <img :src="buttonImage" alt="" />
    </div>
    <!-- <p>{{ text }}</p> -->
  </router-link>
</template>
<script>
import { translateVw, getBusiness } from '../utils/index';
import { mapState } from 'vuex';

export default {
  props: [
    'buttonImage',
    'verticalDirection', // 固定为 top
    'verticalDistance',
    'horizontalDirection', // 'left' | 'right'
    'horizontalDistance',
    'text',
    'linkTo'
  ],
  mounted() {
    this.trackLog(this.text, false, {
      actEventType: 'component_expo'
      // coupon_business_line: this.actData.businessLine
    });
  },
  methods: {
    linkView(link) {
      let isRulePage = link == '/rule';
      let moduleName = isRulePage ? '规则页面' : '我的奖励';
      let eventName = isRulePage ? 'invite_rule_click' : 'invite_reward_click';
      let params = { actEventType: eventName };
      if (!isRulePage) {
        params = {
          ...params,
          activity_business: getBusiness(this.actData.businessLine)
        };
      }
      this.trackLog(moduleName, false, params);
    }
  },
  computed: {
    ...mapState('app', ['activityCode', 'actData']),
    styleObj() {
      let style = {};
      let verticalDirection = this.verticalDirection;
      let horizontalDirection = this.horizontalDirection;
      style[verticalDirection] = translateVw(this.verticalDistance);
      style[horizontalDirection] = translateVw(this.horizontalDistance);
      return style;
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  position: absolute;
  z-index: 1;
  &-img {
    > img {
      width: 88px;
    }
  }
  > p {
    font-size: 24px;
    font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    letter-spacing: 1px;
    margin-top: 8px;
  }
}
</style>
